import { ProgressSpinner } from "primereact/progressspinner"
import { useCallback, useEffect, useState } from "react"
import "./styles.scss"

const NativePDFViewer = ({
  pdf = "",
  height = "",
  type = "base64",
}: {
  pdf?: string | Blob
  height?: string
  type?: "stream" | "base64"
}) => {
  const [finalUrl, setFinalUrl] = useState(null)

  const b64toBlob = (
    b64Data: $TSMigrationFixMe,
    contentType = "",
    sliceSize = 512
  ) => {
    const byteCharacters = atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i += 1) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }

    return new Blob(byteArrays, { type: contentType })
  }

  const transformPdf = useCallback(() => {
    let blob
    switch (type) {
      case "stream":
        blob = new Blob([pdf], { type: "application/pdf" })
        break
      case "base64":
        blob = b64toBlob(pdf, "application/pdf")
        break
      default:
        blob = ""
    }
    // @ts-expect-error TS(2345): Argument of type 'string | Blob' is not assignable...
    const blobUrl = URL.createObjectURL(blob)
    // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par...
    setFinalUrl(blobUrl)
  }, [pdf, type])

  useEffect(() => {
    if (pdf) {
      transformPdf()
    }
  }, [pdf, transformPdf])

  return (
    <div className='pdf-reader tw-w-full !tw-h-full'>
      {finalUrl ? (
        <embed
          src={`${finalUrl}`}
          type='application/pdf'
          width='100%'
          height={height || "100%"}
        />
      ) : (
        <div
          className='pdf-reader--no-file'
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ProgressSpinner />
        </div>
      )}
    </div>
  )
}

export default NativePDFViewer
